import {getTokenValue} from "@atlaskit/tokens";

export function resolveDesignTokenByName(tokenName: string): string {
    return getTokenValue(tokenName as Parameters<typeof getTokenValue>[0], "");
}
